export default "__VITE_ASSET__VETVVEmV__";